import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('kpi.targetDefinition.addKpiBtn'),
    breakpoints: _ctx.targetDefinitionDetailDescriptor.dialog.breakpoints,
    style: _ctx.targetDefinitionDetailDescriptor.dialog.style,
    contentStyle: _ctx.targetDefinitionDetailDescriptor.dialog.contentStyle,
    visible: _ctx.dialogVisible,
    modal: true,
    closable: false,
    class: "p-fluid kn-dialog--toolbar--primary"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.targetDefinition.addKpiBtn')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.addKpi
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.closeKpiDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        paginator: true,
        rows: 15,
        rowsPerPageOptions: [10, 15, 20],
        selection: _ctx.selectedKpi,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedKpi = $event)),
        value: _ctx.kpi,
        loading: _ctx.loadingKpi,
        class: "p-datatable-sm kn-table",
        dataKey: "kpiId",
        responsiveLayout: "stack",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        filterDisplay: "menu",
        scrollable: true,
        scrollHeight: _ctx.targetDefinitionDetailDescriptor.dialog.scrollHeight,
        globalFilterFields: _ctx.targetDefinitionDetailDescriptor.globalFilterFields
      }, {
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: _ctx.$t('common.search'),
                badge: "0",
                "data-test": "search-input"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            headerStyle: "width: 3rem"
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetDefinitionDetailDescriptor.columnsAllKPI, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.field,
              header: _ctx.$t(col.header),
              key: col.field,
              sortable: true,
              class: "kn-truncated"
            }, {
              body: _withCtx((slotProps) => [
                (!col.dateField)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(slotProps.data[slotProps.column.props.field]), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.formatDate(slotProps.data[slotProps.column.props.field])), 1))
              ]),
              _: 2
            }, 1032, ["field", "header"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["selection", "value", "loading", "filters", "scrollHeight", "globalFilterFields"])
    ]),
    _: 1
  }, 8, ["header", "breakpoints", "style", "contentStyle", "visible"]))
}